<template>
  <div id="modalCreateSurvey" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Cadastrar Pesquisa</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="save">
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-12">
                <label class="form-label">
                  Grupo: <span class="text-danger">*</span>
                </label>
                <select
                  class="form-select"
                  :class="{ 'is-invalid': v$.survey.groupId.$errors.length }"
                  v-model="v$.survey.groupId.$model"
                >
                  <option value="" disabled selected>Selecione um grupo</option>
                  <option
                    v-for="group in groups"
                    :key="group.id"
                    :value="group.id"
                  >
                    {{ group.name }}
                  </option>
                </select>
                <span
                  v-if="
                    v$.survey.groupId.required.$invalid &&
                    v$.survey.groupId.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-sm-12">
                <label class="form-label">
                  Nome: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.survey.name.$errors.length }"
                  placeholder="Identificação da Pesquisa"
                  v-model="v$.survey.name.$model"
                />
                <span
                  v-if="
                    v$.survey.name.required.$invalid &&
                    v$.survey.name.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0">
            <button
              type="button"
              class="btn btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              title="Cadastrar Pesquisa"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph ph-spinner spinner" />
              </span>
              <span v-else>Cadastrar</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { showModal, hideModal } from '@/utils/modal'

export default {
  name: 'CreateSurveyModal',

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      survey: {
        groupId: '',
        name: '',
      },
      groups: [],
      disableButton: false,
    }
  },

  methods: {
    async getGroups() {
      try {
        this.groups = await this.$store.dispatch('getGroupsActives')

        if (this.groups.length > 0) {
          showModal('modalCreateSurvey')
        } else {
          this.$root.$refs.notification.warning(
            'Para cadastrar uma pesquisa, é necessário que exista pelo menos um grupo cadastrado e ativo.',
          )
          this.$emit('closeModal', false)
        }
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async save() {
      if (!this.v$.$invalid) {
        this.disableButton = true
        try {
          const response = await this.$store.dispatch(
            'createSurvey',
            this.survey,
          )

          hideModal()
          this.$emit('closeModal', true)
          this.$root.$refs.notification.success(response.message)

          this.$router.push({
            name: 'ParamsSurveysDetails',
            params: { surveyId: response.data },
          })
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },
  },

  validations() {
    return {
      survey: {
        groupId: {
          required,
        },
        name: {
          required,
        },
      },
    }
  },

  mounted() {
    this.getGroups()
  },
}
</script>
